import React from 'react';
import ReadTax from './Read';
import WriteTax from './Write';

export default function Tax(props) {
  const { isUpdate, inputChange, dataProduct } = props; //data Products

  return isUpdate ? (
    <WriteTax inputChange={inputChange} dataProduct={dataProduct} />
  ) : (
    <ReadTax dataProduct={dataProduct} />
  );
}
